'use client'
import type { FC, ReactNode } from 'react'
import { useMemo } from 'react'
import { getCustomTheme } from '#/src/custom/styles/theme'
import { useAppConfigContext } from '#/src/appConfig'
import { ChakraProvider } from '@chakra-ui/react'
import { EmotionRegistry } from 'ui/lib/emotion-registry/EmotionRegistry'

interface ChakraProviderNextProps {
  children: ReactNode
}

const ChakraProviderNext: FC<ChakraProviderNextProps> = ({ children }) => {
  const appConfig = useAppConfigContext()
  const theme = useMemo(() => getCustomTheme(appConfig.theme), [appConfig.theme])

  return (
    <EmotionRegistry>
      <ChakraProvider resetCSS theme={theme}>
        {children}
      </ChakraProvider>
    </EmotionRegistry>
  )
}

export default ChakraProviderNext
